// src/utils/dateHelpers.js

/**
 * Convierte una fecha en formato .NET (/Date(timestamp)/) a objeto Date
 */
export const parseDotNetDate = (dotNetDate) => {
    if (!dotNetDate) return null;

    // Si ya es un objeto Date válido, retornarlo
    if (dotNetDate instanceof Date) return dotNetDate;

    // Si es string con formato /Date(timestamp)/
    if (typeof dotNetDate === 'string' && dotNetDate.startsWith('/Date(')) {
        const timestamp = parseInt(dotNetDate.match(/\d+/)[0]);
        return new Date(timestamp);
    }

    // Si es un timestamp numérico
    if (typeof dotNetDate === 'number') {
        return new Date(dotNetDate);
    }

    // Si es string ISO
    if (typeof dotNetDate === 'string') {
        const date = new Date(dotNetDate);
        return isNaN(date.getTime()) ? null : date;
    }

    return null;
};

/**
 * Formatea una fecha .NET a formato legible
 */
export const formatDotNetDate = (dotNetDate, formatStr = 'dd/MM/yyyy') => {
    const date = parseDotNetDate(dotNetDate);
    if (!date) return '-';

    // Formato simple sin date-fns
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    if (formatStr === 'dd/MM/yyyy') {
        return `${day}/${month}/${year}`;
    }

    if (formatStr === 'dd/MM/yyyy HH:mm') {
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        return `${day}/${month}/${year} ${hours}:${minutes}`;
    }

    return date.toLocaleDateString('es-AR');
};

/**
 * Verifica si una fecha es válida
 */
export const isValidDate = (date) => {
    const parsed = parseDotNetDate(date);
    return parsed && !isNaN(parsed.getTime());
};